import { newAPI } from '../../../services';
import qs from 'qs';

export const fetchServicesScheduling = async (userId, establishmentId, id) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/event_scheduling/services/${id}`);
  return response.data;
}

export const createServicesScheduling = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/event_scheduling/services/new`, qs.stringify(params));
  return response.data;
}

export const updateServicesScheduling = async (userId, establishmentId, id, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/services/${id}`, qs.stringify(params));
  return response.data;
}

export const updateServicesSchedulingConfirmation = async (userId, establishmentId, id) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/services/${id}/toggle-confirmation`);
  return response.data;
}

export const deleteServicesScheduling = async (userId, establishmentId, id, params) => {
  let url = `${userId}/establishment/${establishmentId}/event_scheduling/services/${id}`;

  if(!!params?.recurrence) {
    url = `${userId}/establishment/${establishmentId}/event_scheduling/services/${id}?applyToAll=${params?.recurrence?.applyToAll}`;
  }

  const response = await newAPI.delete(url);
  return response.data;
}

export const fetchServicesExecutionTime = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/event_scheduling/services/execution-time`, qs.stringify(params));
  return response.data;
}